export default "__VITE_ASSET__BiuzeB8g__"